import * as React from 'react';
import { HeaderElements } from "../../HeaderElements/HeaderElements";
export var Impressum = function () {
  return /*#__PURE__*/React.createElement("div", {
    className: "prodwidth center gridreplace infopage l-container h-center c-infopage"
  }, /*#__PURE__*/React.createElement(HeaderElements, {
    title: "Impressum"
  }), /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: window.legal.imprint
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: '2em'
    }
  }, "Durchschnittliche monatliche Nutzerzahl gem. Art. 24 Abs. 2 Digital Services Act: 45.000 (Stand: 01.01.2025)"));
};
export default Impressum;